import { displayDate } from '../../../../../utils/globals/date'
import { TwinDictionary } from '../../../../../utils/globals/dictionary'
import { OrderData } from '../types'

export const addNLineMultiToOrderData = (myOrderData: OrderData, position: number) => {
    for (const element of myOrderData.tableData) {
        if(element.ProductId){
            element.nLine = position
            position++
        }
    }
    return { myOrderData, position}
}

export const fillHeaderForConflicts = (element: TwinDictionary) => {
    return ({
        SupplierId: element.SupplierId,
        CustomerId: element.CustomerId,
        WorkingCenterId: element.WorkingCenterId,
        WorkingCenterCounterId: element.WorkingCenterCounterId,
        WarehouseId: element.WarehouseId,
        BillingWorkingCenterId: element.BillingWorkingCenterId,
        BillingWorkingCenterCounterId: element.BillingWorkingCenterCounterId,
        CurrencyId: element.CurrencyId,
    })
}
export const fillHeaderAfter = (element: TwinDictionary) => {
    return ({
        ...element,
        Customer: element.Customer,
        Supplier: element.Supplier,
        BillingTypeSellOptions: element.BillingTypeSellOptions,
        BillingTypeBuyOptions: element.BillingTypeBuyOptions
    })
}
export const parserConflicts = (currentHeader: TwinDictionary, originalHeader: TwinDictionary) => {
    const conflicts: TwinDictionary = {}
    for (const key in currentHeader) {
        const element = currentHeader[key]
        const originalElement = originalHeader[key] ?? false
        if (originalElement !== false && element !== originalElement) {
            conflicts[key] = true
        }
    }
    return conflicts
}

export const checkBTOIncompatibles = (orders: TwinDictionary[], billingType: 'BillingTypeBuyOptions' | 'BillingTypeSellOptions' ): false | TwinDictionary => {
    const dict: TwinDictionary = { win: '' }
    for (const order of orders) {
        if (order.header[billingType]) {
            const myBillingTypes = order.header[billingType].sort().join('-')
            if (!dict[myBillingTypes]) {
                dict[myBillingTypes] = []
            }
            dict[myBillingTypes].push(order.header.full_assigned_number)
            if (!dict.win) {
                dict.win = myBillingTypes
            } else if (dict[dict.win].length < dict[myBillingTypes].length) {
                dict.win = myBillingTypes
            }
        }
    }
    if (Object.keys(dict).length > 2) {
        return dict
    }
    return false
}

const shippingFieldsToCheck: string[] = ['weight', 'initialPriceWithoutTax', 'finalPriceWithTax', 'finalPriceWithoutTax', 'numberPackages']

export const mergeShipping = (originalShipping: TwinDictionary, currentShipping: TwinDictionary) => {
    if(!Object.keys(originalShipping).length){
        return currentShipping
    }
    for (const field of shippingFieldsToCheck) {
        if (currentShipping[field]){
            originalShipping[field] = parseFloat(originalShipping[field] || '0') + parseFloat(currentShipping[field] || '0')
        }
    }
    originalShipping.typePrice = 1
    return originalShipping
}


type MultiProductsToProcessingTy = {
    products: TwinDictionary[]
}
export interface MultiSelectedTableForProcessingTy {
    forSend: MultiProductsToProcessingTy
}
export const parseMultiSelectedTableForProcessing = (completeData: OrderData) => {
    const parsedData: OrderData = JSON.parse(JSON.stringify(completeData))
    const isSelectedTableData = parsedData?.selectedTableData && parsedData?.selectedTableData?.length ? true : false
    const myTableData = parsedData?.selectedTableData?.length ? parsedData?.selectedTableData : parsedData?.tableData
    const result: MultiSelectedTableForProcessingTy = {
        forSend: {
            products: []
        }
    }
    for (const element of myTableData) {
        let myElement = element
        if (isSelectedTableData && parsedData?.dictPosTableData?.[myElement.id] !== undefined) {
            myElement = parsedData?.tableData[parsedData?.dictPosTableData?.[myElement.id]]
        }
        if (!myElement.processed && myElement.OrderId && myElement?.type !== "addButton") {
            const quantity = parseFloat(myElement.quantity)
            if(quantity > 0){
                result.forSend.products.push({ id: myElement.id, OrderId: myElement.OrderId })
            }
        }
    }
    return result
}

export const addMultiHeaderLine = (products: TwinDictionary[], order: TwinDictionary, type?: string) => {
    let headerLine: TwinDictionary = { reference: order.header.full_assigned_number, custom_name: order.header.custom_name, order_date: displayDate(new Date(order.header.processed_date)), type, notes: order.notes, id: 'order_header_'+order.header.id }
    products.unshift(headerLine)
    return products
}